import { trigger, state, style, animate, transition } from '@angular/animations';

export const questionAnimations = {
  chatExpand: trigger('chatExpand', [
    state('initial', style({
      height: '300px',
      minHeight: '300px'
    })),
    state('expanded', style({
      height: 'calc(100vh - 120px)',
      minHeight: '300px'
    })),
    transition('initial => expanded', [
      animate('0.3s ease-out')
    ])
  ]),
  fadeIn: trigger('fadeIn', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('0.3s ease-out', style({ opacity: 1 }))
    ])
  ]),
  slideFade: trigger('slideFade', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateX(100%)' }),
      animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
    ]),
    transition(':leave', [
      animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' }))
    ])
  ])
}; 